import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Attachment } from '../models/ticket.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  /**
   * Upload an attachment to a ticket
   */
  uploadToTicket(ticketId: string | number, file: File): Observable<HttpEvent<Attachment>> {
    const formData = new FormData();
    formData.append('file', file);

    const req = new HttpRequest('POST', `${this.apiUrl}/tickets/${ticketId}/attachments`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request<Attachment>(req);
  }

  /**
   * Upload an attachment to a comment
   */
  uploadToComment(commentId: string | number, file: File): Observable<HttpEvent<Attachment>> {
    const formData = new FormData();
    formData.append('file', file);

    const req = new HttpRequest('POST', `${this.apiUrl}/comments/${commentId}/attachments`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request<Attachment>(req);
  }

  /**
   * Delete an attachment
   */
  deleteAttachment(attachmentId: string | number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/attachments/${attachmentId}`);
  }

  /**
   * Get the download URL for an attachment
   * (The backend will redirect this to the presigned S3 URL)
   */
  getDownloadUrl(attachmentId: string | number): string {
    return `${this.apiUrl}/attachments/${attachmentId}/download`;
  }
}
